export default __webpack_public_path__ + "static/media/Group 6.593e6ab8.png";